// Wait until DOM is fully loaded
document.addEventListener('DOMContentLoaded', function () {
	var productEl = document.querySelector('.product');
	if (!productEl) return;

	// Utility to wait for required elements to exist
	function waitForElements(selector, callback) {
		var el = document.querySelector(selector);
		if (el) { callback(); return; }

		var observer = new MutationObserver(function () {
			if (document.querySelector(selector)) {
				observer.disconnect();
				callback();
			}
		});
		observer.observe(productEl, { childList: true, subtree: true });

		// Safety timeout — stop after 10s
		setTimeout(function () { observer.disconnect(); }, 10000);
	}

	waitForElements('.product-form__buttons', function () {

		// Ensure jQuery is available
		if (typeof jQuery === 'undefined') {
			console.error('jQuery is not loaded.');
			return;
		}

		var $ = jQuery;

		// Remove extra shop buttons from PDP page 
		$('.product .product-form__buttons .shopify-payment-button').remove();

		// Sticky ATC button
		$('.product-form__buttons').addClass('sticky');

		// Show Back to Top button on scroll
		window.addEventListener('scroll', function () {
			if (window.scrollY > 300) {
				$('#backToTop').fadeIn();
			} else {
				$('#backToTop').fadeOut();
			}
		}, { passive: true });

		// Scroll to top on click
		$('#backToTop').on('click', function () {
			$('html, body').animate({ scrollTop: 0 }, 600);
			return false;
		});

		// Move quantity into button area
		var $quantity = $('.product-form__quantity');
		var $buttons = $('.product-form__buttons');
		var $priceOriginal = $('.no-js-hidden[role="status"]');

		if ($quantity.length && $buttons.length) {
			$quantity.prependTo($buttons);
		}

		// Move price into button on mobile
		function movePriceToMobile() {
			if (window.innerWidth <= 749) {
				$('.mobile-price').remove();
				var $submitBtn = $('.product-form__submit');
				$priceOriginal = $('.no-js-hidden[role="status"]');
					if ($priceOriginal.length) {
					var $clone = $priceOriginal.clone().addClass('mobile-price').show();
					$clone.find('.price').show();
					$submitBtn.append($clone);
				}
			}
		}

		// Restore price for desktop view
		function restorePrice() {
			$('.mobile-price').remove();
			$priceOriginal.show();
			$priceOriginal.find('.price').show();
		}

		// Remove USD text from price
		function removeUSD() {
			$('.price .price__regular .price-item').each(function () {
				var text = $(this).text();
				$(this).text(text.replace(/usd/i, '').trim());
			});
		}

		// Initial actions for mobile
		if (window.innerWidth <= 749) {
			movePriceToMobile();
			removeUSD();
		}

		// On resize
		window.addEventListener('resize', function () {
			if (window.innerWidth <= 749) {
				movePriceToMobile();
				removeUSD();
			} else {
				restorePrice();
			}
		});

		// On variant or size change — wait for Shopify price DOM update instead of blind timeout
		$(document).on('change', '.product-form__input select, .product-form__input input[name="Size"]', function () {
			$('.mobile-price').remove();
			var priceEl = document.querySelector('.no-js-hidden[role="status"]');
			if (!priceEl) { movePriceToMobile(); removeUSD(); return; }

			var priceObserver = new MutationObserver(function () {
				priceObserver.disconnect();
				movePriceToMobile();
				removeUSD();
			});
			priceObserver.observe(priceEl, { childList: true, subtree: true, characterData: true });
			// Fallback if price doesn't update within 2s
			setTimeout(function () { priceObserver.disconnect(); movePriceToMobile(); removeUSD(); }, 2000);
		});

		//update price based on quantity selection
		// var regular = {}, sale = {};
 
		// function parsePrice($el) {
		// 	var text = $el.text().trim();
		// 	return {
		// 		prefix: (text.match(/^[^\d]+/) || ["$"])[0].trim(),
		// 		suffix: (text.match(/[^\d]+$/) || [""])[0].trim(),
		// 		value: parseFloat(text.replace(/[^0-9.]/g, ""))
		// 	};
		// }
	
		// function setBasePrices() {
		// 	regular = parsePrice($(".price-per-piece-wrapper .price-item--regular:first"));	
		// 	console.log(regular);
				
		// 	sale = parsePrice($(".price-per-piece-wrapper .price-item--sale:first"));		
		// }
	
		// function updateCartPrice() {
		// 	console.log(regular);
			
		// 	var qty = parseInt($(".product-form__buttons .quantity__input").val()) || 1;
		// 	console.log(qty);
			
		// 	$(".price__regular .price-item--regular").text(regular.prefix + (regular.value * qty).toFixed(2) + " " + regular.suffix);
		// 	$(".price__sale .price-item--sale, .price__sale .price-item--regular").text(sale.prefix + (sale.value * qty).toFixed(2) + " " + sale.suffix);
		// }
	
		// $(".product-form__buttons button[name='minus'], .product-form__buttons button[name='plus'], .quantity__input").on("click input", updateCartPrice);
	
		// setBasePrices();

	});

	// Yotpo review button + summary repositioning (merged, scoped observer)
	jQuery(function ($) {
		var reviewBtnDone = false;
		var summaryDone = false;

		var observer = new MutationObserver(function () {
			if (!reviewBtnDone) {
				var button = $('.product .yotpo-new-review-button');
				var target = $('.product .yotpo-bottom-line-summary');
				if (button.length && target.length) {
					button.appendTo(target);
					reviewBtnDone = true;
				}
			}

			if (!summaryDone) {
				var summary = $('.product .product-review-summaries-wrapper');
				var headerTarget = $('.product .yotpo-header-container');
				if (summary.length && headerTarget.length && !headerTarget.find('.product-review-summaries-wrapper').length) {
					summary.appendTo(headerTarget);
					summaryDone = true;
				}
			}

			if (reviewBtnDone && summaryDone) observer.disconnect();
		});

		observer.observe(productEl, { childList: true, subtree: true });
		setTimeout(function () { observer.disconnect(); }, 15000);
	});

});

// Issue 9 — Add accessible titles to unlabeled iframes (Shopify analytics frames)
(function () {
  function labelUnnamedIframes() {
    document.querySelectorAll('iframe:not([title]):not([aria-label])').forEach(function (frame) {
      frame.setAttribute('title', 'Analytics Tracking');
    });
  }

  // Label any already-present iframes
  labelUnnamedIframes();

  // Watch for iframes injected after page load
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeName === 'IFRAME' && !node.title && !node.getAttribute('aria-label')) {
          node.setAttribute('title', 'Analytics Tracking');
        }
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();

// Issue 16 — Remove keyboard tabindex from UpCart cart heading
(function () {
  function removeCartHeadingTabindex() {
    document.querySelectorAll('.upcart-header-text[tabindex]').forEach(function (el) {
      el.removeAttribute('tabindex');
    });
  }

  // Run immediately in case element already exists
  removeCartHeadingTabindex();

  // Watch for UpCart injecting the heading dynamically
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (!node.querySelectorAll) return;
        node.querySelectorAll('.upcart-header-text[tabindex]').forEach(function (el) {
          el.removeAttribute('tabindex');
        });
        if (node.classList && node.classList.contains('upcart-header-text') && node.hasAttribute('tabindex')) {
          node.removeAttribute('tabindex');
        }
      });
    });
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();

// Issue 5 — Fix UpCart cart drawer ARIA dialog accessibility
(function () {
  var lastFocusedElement = null;

  // Collect all focusable elements within a container
  function getFocusableElements(container) {
    return Array.from(container.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), ' +
      'textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )).filter(function (el) {
      return el.offsetParent !== null;
    });
  }

  // Trap Tab focus inside the drawer
  function handleFocusTrap(container, event) {
    var focusable = getFocusableElements(container);
    if (!focusable.length) return;
    var first = focusable[0];
    var last  = focusable[focusable.length - 1];

    if (event.key === 'Tab') {
      if (event.shiftKey) {
        if (document.activeElement === first) {
          event.preventDefault();
          last.focus();
        }
      } else {
        if (document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }
    }
  }

  // Patch the UpCart drawer with ARIA dialog attributes
  function patchDrawer(drawer) {
    if (drawer.dataset.a11yPatched) return;
    drawer.dataset.a11yPatched = 'true';

    // ARIA dialog role and label
    drawer.setAttribute('role', 'dialog');
    drawer.setAttribute('aria-modal', 'true');

    // Use existing heading as label if present, else fall back to aria-label
    var heading = drawer.querySelector('.upcart-header-text');
    if (heading) {
      if (!heading.id) heading.id = 'upcart-dialog-heading';
      drawer.setAttribute('aria-labelledby', 'upcart-dialog-heading');
    } else {
      drawer.setAttribute('aria-label', 'Shopping Cart');
    }

    // Focus trap + Escape to close
    drawer.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        var closeBtn = drawer.querySelector(
          '[data-upcart-close], .upcart-close-btn, button.upcart-close, ' +
          '[aria-label="Close"], [aria-label="close"], button[class*="close"]'
        );
        if (closeBtn) closeBtn.click();
        if (lastFocusedElement) {
          lastFocusedElement.focus();
          lastFocusedElement = null;
        }
        return;
      }
      handleFocusTrap(drawer, e);
    });
  }

  // Track the element that triggered cart open
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest(
      '[data-upcart-open], .upcart-cart-icon, ' +
      '#CartIconBubble, #cart-icon-bubble, [href*="/cart"], ' +
      '[aria-label*="cart" i], [class*="cart-icon"]'
    );
    if (trigger) lastFocusedElement = trigger;
  }, true);

  // Detect when UpCart injects or opens the drawer
  function observeDrawer() {
    var mutObs = new MutationObserver(function () {
      var drawer = document.querySelector(
        '.upcart-wrapper, .upcart-drawer, #upcart, ' +
        '[class*="upcart"][class*="drawer"], [class*="upcart"][class*="wrapper"]'
      );
      if (!drawer) return;

      // Patch structure
      patchDrawer(drawer);

      // Move focus into drawer when it becomes visible
      var isVisible = drawer.offsetParent !== null &&
                      getComputedStyle(drawer).display !== 'none' &&
                      getComputedStyle(drawer).visibility !== 'hidden';
      if (isVisible && !drawer.dataset.a11yFocused) {
        drawer.dataset.a11yFocused = 'true';
        var focusTarget = drawer.querySelector(
          '[data-upcart-close], .upcart-close-btn, button[class*="close"], button'
        );
        if (focusTarget) setTimeout(function () { focusTarget.focus(); }, 80);
      }

      // Reset focused flag when drawer closes
      if (!isVisible && drawer.dataset.a11yFocused) {
        delete drawer.dataset.a11yFocused;
      }
    });

    mutObs.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class', 'open']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeDrawer);
  } else {
    observeDrawer();
  }
})();

// =============================================================================
// Issue 8 — Add aria-labels to Yotpo review carousel slides
// Issue 10 — Fix broken aria-labelledby references in dynamically-rendered carousels
// =============================================================================
(function () {
  'use strict';

  // Issue 8: Label each Yotpo review carousel slide with "Review X of Y"
  function labelYotpoSlides() {
    // Yotpo carousel renders slides as list items inside the widget
    var carousels = document.querySelectorAll(
      '.yotpo-widget-instance, [data-yotpo-instance-id]'
    );
    carousels.forEach(function (carousel) {
      if (carousel.dataset.a11yLabeled) return;

      // Target individual review slides — Yotpo uses these classes
      var slides = carousel.querySelectorAll(
        '.yotpo-carousel-review, [class*="reviewCarouselCard"], ' +
        '[class*="review-carousel-card"], [class*="carousel-item"]'
      );
      if (!slides.length) return;

      var total = slides.length;
      slides.forEach(function (slide, index) {
        if (!slide.getAttribute('aria-label')) {
          slide.setAttribute('role', 'group');
          slide.setAttribute('aria-label', 'Review ' + (index + 1) + ' of ' + total);
        }
      });
      carousel.dataset.a11yLabeled = 'true';
    });
  }

  // Issue 10: Find any aria-labelledby pointing to a non-existent ID and fix it
  function fixBrokenAriaLabelledBy() {
    document.querySelectorAll('[aria-labelledby]').forEach(function (el) {
      var ids = el.getAttribute('aria-labelledby').split(/\s+/);
      var allExist = ids.every(function (id) {
        return id && document.getElementById(id);
      });
      if (!allExist) {
        // Build a label from the IDs that DO exist, discard the missing ones
        var labelParts = ids
          .map(function (id) {
            var ref = document.getElementById(id);
            return ref ? ref.textContent.trim() : null;
          })
          .filter(Boolean);

        if (labelParts.length) {
          // Replace broken aria-labelledby with a direct aria-label from existing refs
          el.removeAttribute('aria-labelledby');
          el.setAttribute('aria-label', labelParts.join(' '));
        } else {
          // No referenced elements exist at all — remove the broken attribute
          el.removeAttribute('aria-labelledby');
        }
      }
    });
  }

  function runFixes() {
    labelYotpoSlides();
    fixBrokenAriaLabelledBy();
  }

  // Run on initial load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runFixes);
  } else {
    runFixes();
  }

  // Re-run when Yotpo or other dynamic content injects into the DOM
  var observer = new MutationObserver(function (mutations) {
    var relevant = mutations.some(function (m) {
      return m.addedNodes.length > 0;
    });
    if (relevant) runFixes();
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();